// src/components/TransitionOverlay.jsx
import React, { useContext, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useTransitionStore } from "../@shared/store/useTransitionStore";
import AudioManager from "../@shared/utils/AudioManager";
import { useLocation } from "react-router-dom";
import { MainContext } from "../App";

const doorStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: 9999,
};

const lockStyle = {
  position: "absolute",
  top: window.innerWidth >= 900 ? "30%" : "27%",
  left: window.innerWidth >= 900 ? "40%" : "13%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  height: "fit-content",
  zIndex: 10000,
};

const getCurrentPath = () => window.location.pathname;

export default function TransitionOverlay() {
  const topControls = useAnimation();
  const bottomControls = useAnimation();
  const lockControls = useAnimation();

  const { screenLoading } = useContext(MainContext);

  useEffect(() => {
    console.log("screenLoading:", screenLoading);
  }, [screenLoading]);

  useEffect(() => {
    const startAnimation = async () => {
      console.log("🎬 Starting transition animation");

      AudioManager.playSFX("doorTransition");

      // 🔧 Let DOM + animation controls settle
      await new Promise(requestAnimationFrame);

      console.log("🎞 Sliding doors in...");
      await Promise.all([
        topControls.start({ y: "0%", transition: { duration: 0.5 } }),
        bottomControls.start({ y: "0%", transition: { duration: 0.5 } }),
        lockControls.start({
          display: "block",
          opacity: 1,
          rotate: 180,
          y: "0%",
          transition: { duration: 0.5 },
        }),
      ]);

      console.log("✅ Start animation complete, starting finish Animation");
    };

    const finishAnimation = async () => {
      console.log("🔒 Animating lock...");
      await lockControls.start({
        opacity: 1,
        rotate: [180, 180, 0, 0],
        // y: "-200%",
        // y: [-200, -200, 0, 0],
        transition: { duration: 1 },
      });

      lockControls.set({ display: "none" });

      console.log("🎞 Sliding doors out...");
      await Promise.all([
        topControls.start({ y: "-100%", transition: { duration: 0.5 } }),
        bottomControls.start({ y: "100%", transition: { duration: 0.5 } }),
        lockControls.start({
          //   opacity: 0,
          y: "-200%",
          transition: { duration: 0.3 },
        }),
      ]);

      console.log("✅ Transition animation complete, calling onComplete");
    };

    if (screenLoading) {
      startAnimation();
    }

    if (!screenLoading) {
      finishAnimation();
    }

    console.log("screenLoading:", screenLoading);
  }, [screenLoading]);

  //   if (!isVisible && !animating) return null;

  return (
    <>
      <motion.div
        initial={{ y: "-100%" }}
        animate={topControls}
        style={{ ...doorStyle, top: 0 }}
      >
        <img
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transform: "rotate(180deg)",
          }}
          src={require("../@shared/assets/web-door-image.png")}
          alt=""
        />
      </motion.div>
      <motion.div
        initial={{ y: "100%" }}
        animate={bottomControls}
        style={{
          ...doorStyle,
          top: "auto",
          bottom: 0,
          //   transform: "scaleY(-1)",
        }}
      >
        <div
          style={{
            height: "100%",
            width: "100%",
            position: "relative",
          }}
        >
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            src={require("../@shared/assets/web-door-image.png")}
            alt=""
          />
          <motion.div
            initial={{ opacity: 0 }}
            animate={lockControls}
            style={{ ...lockStyle }}
          >
            <img
              src={require("../@shared/assets/web-door-lock.png")}
              style={{ width: 300, height: 300 }}
              alt=""
            />
          </motion.div>
        </div>
      </motion.div>
    </>
  );
}
